var _rect, _path, _path2, _path3, _circle, _circle2, _circle3, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecuramind(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 520,
    fill: "#17122b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400 125c-92 0-166 70-166 156 0 59 35 105 83 131v45h166v-45c48-26 83-72 83-131 0-86-74-156-166-156z",
    fill: "#6d28d9",
    stroke: "#c4b5fd",
    strokeWidth: 7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M320 260h48l22-48 35 105 24-58h43",
    fill: "none",
    stroke: "#f0abfc",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M345 390h110M360 420h80",
    stroke: "#ddd6fe",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 180,
    r: 10,
    fill: "#facc15"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 640,
    cy: 270,
    r: 10,
    fill: "#22d3ee"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 620,
    cy: 125,
    r: 7,
    fill: "#fb7185"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 75,
    fill: "#ede9fe",
    fontFamily: "sans-serif",
    fontSize: 44,
    fontWeight: 700
  }, "SECURAMIND")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 475,
    fill: "#c4b5fd",
    fontFamily: "monospace",
    fontSize: 22
  }, "AI-POWERED SECURE CODE ASSISTANT")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuramind);
export default __webpack_public_path__ + "static/media/securamind.3b8f608a8e597922aa77a127cb230800.svg";
export { ForwardRef as ReactComponent };